const SPLASH_ID = "app-splash";
const MIN_DISPLAY_MS = 1500;
const MAX_DISPLAY_MS = 3000;
const FADE_MS = 400;

let splashEl = null;
let startedAt = 0;
let hideScheduled = false;
let forceHideTimer = null;
let destroyed = false;

function removeOverlay() {
  if (splashEl && splashEl.parentNode) {
    splashEl.parentNode.removeChild(splashEl);
  }
  splashEl = null;
}

export function initBrowserSplash() {
  if (destroyed) return;
  splashEl = document.getElementById(SPLASH_ID);
  if (!splashEl) return;
  startedAt = Date.now();

  forceHideTimer = setTimeout(() => hideBrowserSplash(), MAX_DISPLAY_MS);
}

export function hideBrowserSplash() {
  if (!splashEl) return;
  if (hideScheduled) return;

  if (!startedAt) startedAt = Date.now();

  const elapsed = Date.now() - startedAt;
  if (elapsed < MIN_DISPLAY_MS) {
    hideScheduled = true;
    setTimeout(() => {
      hideScheduled = false;
      hideBrowserSplash();
    }, MIN_DISPLAY_MS - elapsed);
    return;
  }

  if (forceHideTimer) {
    clearTimeout(forceHideTimer);
    forceHideTimer = null;
  }
  destroyed = true;
  splashEl.classList.add("app-splash-hidden");
  setTimeout(removeOverlay, FADE_MS);
}
